export enum UserProfileEditableField {
    Name, Email, City, PostalCode, Street, Country, State
}